import CONST from './const';

export const numberFormat = x => {
  return isNaN(x)
    ? ""
    : x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, CONST.format.numberSeparator);
};
